import { Extension } from '@tiptap/react';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    fontSize: {
      /**
       * Set the font size
       */
      setFontSize: (size: string) => ReturnType;
      /**
       * Unset the font size
       */
      unsetFontSize: () => ReturnType;
    };
  }
}

export const FontSize = Extension.create({
    name: 'fontSize',

    addOptions() {
        return {
            types: ['textStyle'],
        };
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: (element) => {
                            const fontSize = element.style.fontSize;
                            // Safely parse and return font size, stripping out 'px' if present
                            return fontSize ? fontSize.replace(/['"]+/g, '') : null;
                        },
                        renderHTML: (attributes) => {
                            // Only apply style if fontSize exists
                            if (attributes.fontSize) {
                                return {
                                    style: `font-size: ${attributes.fontSize}`,
                                };
                            }
                            return {};
                        },
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setFontSize: (fontSize) => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { fontSize: fontSize + 'px' }) // Add 'px' to ensure proper font size format
                    .run();
            },

            unsetFontSize: () => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { fontSize: null }) // Remove font size if set
                    .removeEmptyTextStyle() // Clean up textStyle if no attributes are left
                    .run();
            },
        };
    },
});
